/* assets/variant-images-controller.js */
(function(){
  var TAG='[VariantImagesDBG]';
  var log = function(){ try{ console.log.apply(console,[TAG].concat([].slice.call(arguments))); }catch(e){} };
  var warn=function(){ try{ console.warn.apply(console,[TAG].concat([].slice.call(arguments))); }catch(e){} };
  var err =function(){ try{ console.error.apply(console,[TAG].concat([].slice.call(arguments))); }catch(e){} };

function initFor(root){
  if(!root || root.nodeType !== 1) return;

  // Only proceed if this element actually contains the product gallery
  var gallery = root.matches('[data-js-product-gallery]') ? root : root.querySelector('[data-js-product-gallery]');
  if(!gallery){
    // noisy logs? comment out next line
    log('Skip: no gallery in', root.tagName + '#' + (root.getAttribute && root.getAttribute('id') || ''));
    return;
  }

  if(root.__variantImagesInit){ log('Already initialized for', root.getAttribute && root.getAttribute('id')); return; }

  // Use attribute so we always get a string (avoids form[name="id"] shadowing)
  var sectionId = String(root.getAttribute('id') || '').replace(/^product-/, '');
  var productId = root.getAttribute('data-id') || (gallery.closest('[data-id]') && gallery.closest('[data-id]').getAttribute('data-id'));
  log('Init for section', sectionId, 'product', productId);

  // now safe to mark as initialized
  root.__variantImagesInit = true;

    var gallery = root.querySelector('[data-js-product-gallery]');
    if(!gallery){ return err('Gallery container not found'); }
    var grid = gallery.querySelector('.grid');
    if(!grid){ return err('Gallery .grid not found'); }

    var cssSlider = gallery.closest('css-slider') || gallery.querySelector('css-slider');
    var dotNav   = root.querySelector('.css-slider-dot-navigation');
    var thumbs   = root.querySelector('.product-gallery__thumbnails-holder');

    var fallbackHTML = grid.innerHTML;
    log('DOM ok', {hasCssSlider:!!cssSlider, hasDotNav:!!dotNav, hasThumbs:!!thumbs, fallbackLen:fallbackHTML.length});

    // Load the Liquid-produced map for this section
    var mapEl = document.getElementById('variant-images-map-' + sectionId);
    if(!mapEl){ warn('Map element not found for section', sectionId); }
    var map = {};
    try { map = JSON.parse((mapEl && mapEl.textContent) || '{}'); }
    catch(e){ err('Failed parsing variant-images map', e); }

    // Quick summary
    var counts={}; Object.keys(map).forEach(function(k){ counts[k]=(map[k]||[]).length; });
    log('Map counts per variant:', counts);

    function setDotCount(n){
      if(dotNav) { dotNav.style.setProperty('--size', n); log('Dot count ->', n); }
    }

    function renderImages(images){
      if(!Array.isArray(images) || images.length===0){
        log('Render FALLBACK product.media');
        grid.innerHTML = fallbackHTML;
        setDotCount(grid.querySelectorAll('.product-gallery-item').length);
        // Try to tell css-slider
        if(cssSlider && typeof cssSlider.reload==='function'){
          try{ cssSlider.reload(); log('css-slider reloaded (fallback)'); }catch(e){ warn('css-slider.reload failed', e); }
        }
        return;
      }

      log('Render', images.length, 'variant images');
      grid.innerHTML = '';
      // inside renderImages(...)
      images.forEach(function(img, i){
        var item = document.createElement('div');
        item.className = 'product-gallery-item';
        item.setAttribute('data-index', i);   // <-- add this
        item.style.paddingTop = 'calc(100% / ' + (window.__PRODUCT_GALLERY_AR || '{{ section.settings.gallery_aspect_ratio }}') + ')';

        var holder = document.createElement('div');
        holder.className = 'lazy-image lazy-image--fit lazy-image--to-reveal';

        var el = document.createElement('img');
        el.src = img.src; el.alt = img.alt || ''; el.loading = 'lazy';
        holder.appendChild(el); item.appendChild(holder); grid.appendChild(item);
      });


      setDotCount(images.length);

      if(thumbs){
        thumbs.innerHTML = images.map(function(img, i){
          return '<button class="thumbnail element--border-radius" data-index="'+i+'">' +
                   '<img class="thumbnail__image" src="'+img.thumb+'" alt="'+(img.alt||'')+'">' +
                 '</button>';
        }).join('');
        log('Thumbnails rendered:', images.length);
      }

      if(cssSlider && typeof cssSlider.reload==='function'){
        try{ cssSlider.reload(); log('css-slider reloaded (variant)'); }catch(e){ warn('css-slider.reload failed', e); }
      }
    }

    function getActiveVariantId(){
      var idInput = root.querySelector('form input[name="id"]');
      var v = idInput && idInput.value;
      if(!v) warn('Hidden input[name="id"] missing or empty');
      return v;
    }

    function showForVariant(vid){
      if(!vid){ return warn('showForVariant: no variant id'); }
      var imgs = map[String(vid)] || [];
      log('showForVariant', vid, 'images:', imgs.length);
      renderImages(imgs);
    }

    // Initial render
    var currentId = getActiveVariantId();
    log('Initial variant id:', currentId);
    showForVariant(currentId);
    

    // Listen to common variant change events
    function onVariantEvent(e){
      var d = (e && e.detail) || {};
      var vid = d.variant_id || (d.variant && d.variant.id) || getActiveVariantId();
      log('Variant event:', e.type, 'detail:', d, '->', vid);
      if(vid && vid !== currentId){ currentId = vid; showForVariant(vid); }
    }
    ['variant:change','variantChange','product:variant-change','product:variant:change','variant:changed']
      .forEach(function(evt){ root.addEventListener(evt, onVariantEvent); document.addEventListener(evt, onVariantEvent); });

    // Watch option inputs as fallback
    root.addEventListener('change', function(e){
      if(e.target && (e.target.matches('select[name^="options"]') || e.target.matches('input[name^="options"]'))){
        setTimeout(function(){
          var vid = getActiveVariantId();
          if(vid && vid !== currentId){ log('Options change ->', vid); currentId = vid; showForVariant(vid); }
        }, 0);
      }
    });

    // Observe the variant JSON block some themes update
    var dataScript = root.querySelector('script[data-js-variant-data]');
    if(dataScript){
      var obs = new MutationObserver(function(){
        var txt = (dataScript.textContent||'').trim(); if(!txt) return;
        try{ var v = JSON.parse(txt); var vid = v && v.id;
          if(vid && vid !== currentId){ log('variant-data changed ->', vid); currentId = vid; showForVariant(vid); }
        }catch(e){ warn('variant-data parse fail', e); }
      });
      obs.observe(dataScript, {childList:true, characterData:true, subtree:true});
      log('Observing script[data-js-variant-data]');
    }else{
      warn('script[data-js-variant-data] not found');
    }
  }

  function boot(context){
    (context || document).querySelectorAll('[id^="product-"]').forEach(initFor);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(document); });
  } else {
    boot(document);
  }

  // Re-run when theme editor reloads the section
  document.addEventListener('shopify:section:load', function(e){ boot(e.target||document); });

  // expose for manual debugging
  window.__VariantImages = { boot: boot };
})();
/* Mobile slider image override – builds visible images for current variant */
(function () {
  var TAG = '[VariantImagesMOBILE]';
  function log()  { try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {} }
  function warn() { try { console.warn.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {} }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function getVariantMap(sectionId) {
    var el = document.getElementById('variant-images-map-' + sectionId);
    if (!el) {
      warn('No map element for section', sectionId);
      return {};
    }
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      warn('Map JSON parse failed for section', sectionId, e);
      return {};
    }
  }

  function getCurrentVariantId(root) {
    // Prefer the main variant JSON
    var dataScript = root.querySelector('script[data-js-variant-data][data-update-block="variant-data-main-product"]');
    if (dataScript && dataScript.textContent.trim()) {
      try {
        var v = JSON.parse(dataScript.textContent);
        if (v && v.id) return String(v.id);
      } catch (e) {
        warn('Failed parsing main variant JSON', e);
      }
    }
    // Fallback to hidden id input
    var idInput = root.querySelector('form[action="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);
    return null;
  }

  function applyMobileImages(root, variantId) {
    if (!isMobile()) return;
    if (!variantId) return;

    var rootId = root.getAttribute('id') || '';
    var sectionId = String(rootId).replace(/^product-/, '');

    var map = getVariantMap(sectionId);
    var list = map[variantId];
    if (!Array.isArray(list) || !list.length) {
      log('No variant images in map for', variantId, 'section', sectionId);
      return;
    }

    var gallery = root.querySelector('[data-js-product-gallery]');
    if (!gallery) {
      warn('No [data-js-product-gallery] under root', rootId);
      return;
    }

    // Big images inside slider
    var bigImgs = gallery.querySelectorAll('.product-gallery-item img');
    // Thumbnails, if any
    var thumbImgs = gallery.querySelectorAll('.product-gallery__thumbnails-holder img.thumbnail__image');

    log('applyMobileImages for variant', variantId, 'bigImgs:', bigImgs.length, 'thumbImgs:', thumbImgs.length, 'map images:', list.length);

    // Update big images (one-to-one, extra nodes get cycled)
    for (var i = 0; i < bigImgs.length; i++) {
      var data = list[i] || list[i % list.length];
      if (!data) continue;
      var node = bigImgs[i];

      node.src = data.src;
      node.removeAttribute('srcset');
      if (data.alt) node.alt = data.alt;
    }

    // Update thumbnails (if present)
    for (var j = 0; j < thumbImgs.length; j++) {
      var tData = list[j] || list[j % list.length];
      if (!tData) continue;
      var tNode = thumbImgs[j];

      tNode.src = tData.thumb || tData.src;
      tNode.removeAttribute('srcset');
      if (tData.alt) tNode.alt = tData.alt;
    }

    // Optional: make sure first slide is active on mobile
    var slider = gallery.querySelector('css-slider');
    if (slider) {
      var slides = gallery.querySelectorAll('.product-gallery-item');
      slides.forEach(function (s, idx) {
        s.classList.remove('css-slide-active');
        if (idx === 0) s.classList.add('css-slide-active');
      });
      // try to let theme recalc, if available
      if (typeof slider.reload === 'function') {
        try { slider.reload(); } catch (e) { warn('slider.reload failed', e); }
      }
    }
  }

  function attachToRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (!/^product-/.test(root.id || '')) return;

    if (root.__variantImagesMobileBound) return;
    root.__variantImagesMobileBound = true;

    log('Bind mobile override for', root.id);

    function refresh() {
      if (!isMobile()) return;
      var vid = getCurrentVariantId(root);
      log('refresh mobile images, vid =', vid);
      if (vid) applyMobileImages(root, vid);
    }

    // Initial run on load (mobile only)
    refresh();

    // Listen to the same variant events the theme / your first script uses
    [
      'VARIANT_CHANGE',
      'variant:change',
      'variantChange',
      'product:variant-change',
      'product:variant:change',
      'variant:changed'
    ].forEach(function (evt) {
      root.addEventListener(evt, function () { setTimeout(refresh, 0); });
      document.addEventListener(evt, function () { setTimeout(refresh, 0); });
    });

    // Also watch the main variant JSON block
    var dataScript = root.querySelector('script[data-js-variant-data][data-update-block="variant-data-main-product"]');
    if (dataScript) {
      new MutationObserver(function () {
        setTimeout(refresh, 0);
      }).observe(dataScript, { childList: true, characterData: true, subtree: true });
    }
  }

  function boot(context) {
    (context || document)
      .querySelectorAll('[id^="product-"]')
      .forEach(attachToRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();


/* Manual navigation for css-slider prev/next + dots, via event delegation */
(function () {
  var TAG = '[CssSliderNavDelegated]';
  function log()  { try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {} }
  function warn() { try { console.warn.apply(console, [TAG].concat([].slice.call(arguments))); } catch (e) {} }

  if (window.__CssSliderNavDelegatedBound) {
    return; // don't bind twice
  }
  window.__CssSliderNavDelegatedBound = true;

  function getSlides(slider) {
    return Array.prototype.slice.call(
      slider.querySelectorAll('.product-gallery-item.css-slide, .product-gallery-item')
    );
  }

  function getDots(slider) {
    return Array.prototype.slice.call(
      slider.querySelectorAll('.css-slider-dot-navigation .css-slider-dot')
    );
  }

  function getScrollContainer(slider) {
    // product gallery root
    var gallery = slider.closest('[data-js-product-gallery]') || slider;
    // real scroll div on your theme
    var scroller =
      gallery.querySelector('.lap--grid--slider.grid-1') ||
      gallery.querySelector('.lap--grid--slider') ||
      gallery.querySelector('.css-slider-viewport') ||
      gallery.querySelector('.css-slider-holder') ||
      gallery.querySelector('.css-slider-container') ||
      slider;

    return scroller;
  }

  function getCurrentIndex(slider) {
    var slides = getSlides(slider);
    if (!slides.length) return 0;
    var idx = slides.findIndex(function (s) {
      return s.classList.contains('css-slide-active');
    });
    return idx >= 0 ? idx : 0;
  }

  function goTo(slider, index) {
    var slides = getSlides(slider);
    var dots   = getDots(slider);

    if (!slides.length) {
      log('goTo: no slides');
      return;
    }

    var maxIndex = slides.length - 1;
    if (index < 0) index = 0;
    if (index > maxIndex) index = maxIndex;

    // update slides & inert
    slides.forEach(function (slide, i) {
      if (i === index) {
        slide.classList.add('css-slide-active');
        slide.removeAttribute('inert');
      } else {
        slide.classList.remove('css-slide-active');
        slide.setAttribute('inert', '');
      }
    });

    // update dots
    dots.forEach(function (dot) {
      var dotIndex = parseInt(dot.getAttribute('data-index'), 10);
      if (dotIndex === index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    // scroll the real horizontal container
    var scroller = getScrollContainer(slider);
    var target   = slides[index];
    if (!scroller || !target) {
      warn('goTo: missing scroller or target', !!scroller, !!target);
      return;
    }

    // Use rect math so we don't care about exact widths
    var sRect = scroller.getBoundingClientRect();
    var tRect = target.getBoundingClientRect();
    var delta = tRect.left - sRect.left;
    var left  = scroller.scrollLeft + delta;

    log(
      'goTo index=', index,
      'scroller=', scroller.tagName + '.' + scroller.className,
      'delta=', delta,
      'scrollLeft→', left
    );

    try {
      scroller.scrollTo({ left: left, behavior: 'smooth' });
    } catch (e) {
      scroller.scrollLeft = left;
    }
  }

  // Normalise event target → slider + index
  function handleClick(target) {
    // prev / next buttons
    var prevBtn = target.closest('.css-slider-button.css-slider-prev');
    var nextBtn = target.closest('.css-slider-button.css-slider-next');
    var dot     = target.closest('.css-slider-dot');

    if (!prevBtn && !nextBtn && !dot) return;

    var slider = (prevBtn || nextBtn || dot).closest('css-slider');
    if (!slider) return;

    if (prevBtn || nextBtn) {
      var current = getCurrentIndex(slider);
      var nextIdx = prevBtn ? current - 1 : current + 1;
      log(prevBtn ? 'prev click' : 'next click', 'current=', current, 'next=', nextIdx);
      goTo(slider, nextIdx);
      return;
    }

    if (dot) {
      var idx = parseInt(dot.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      log('dot click idx=', idx);
      goTo(slider, idx);
      return;
    }
  }

  // One global click listener
  document.addEventListener('click', function (e) {
    handleClick(e.target);
  }, true); // capture so we get it even if theme stops propagation

  log('Delegated nav bound');
})();


